import { z } from 'zod';

export type SuggestedDriverDTO = z.infer<typeof suggestedDriverSchema>;
const suggestedDriverSchema = z.object({
  driver: z.object({
    guid: z
      .string()
      .nullish()
      .transform((value) => value ?? ''),
    name: z
      .string()
      .nullish()
      .transform((value) => value ?? ''),
    truck_size: z.number().nullable().default(null),
  }),
  reasons: z
    .array(z.string())
    .nullish()
    .transform((value) => value ?? []),
});

export type SuggestedDriversDTO = z.infer<typeof suggestedDriversSchema>;
export const suggestedDriversSchema = z.object({
  suggestions: z
    .array(suggestedDriverSchema)
    .nullish()
    .transform((value) => value ?? []),
});
